import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { useAuth } from '@/hooks/use-auth'
import { useCompanies } from '@/hooks/use-companies'
import { createInfestationReport } from '@/services/create-infestation-report'
import { queryClient } from '@/services/query-client'

import { GET_INFESTATION_REPORTS_QUERY } from '../queries/use-get-infestation-reports'

interface CreateInfestationReportPayload {
  id?: string
  weed_type_by_culture: {
    cane: string[] | []
    soybean: string[] | []
  }
  ordered_by:
    | 'demand_name'
    | '-demand_name'
    | 'created_at'
    | '-created_at'
    | 'infestation_percentage'
    | '-infestation_percentage'
    | 'total_area'
    | '-total_area'
  initial_conclusion_date: string
  final_conclusion_date: string
}

export const useCreateInfestationReport = () => {
  const { user } = useAuth()
  const { selectedCompany } = useCompanies()

  const mutation = useMutation(
    async (payload: CreateInfestationReportPayload) =>
      createInfestationReport({
        company: {
          id: selectedCompany.id,
          name: selectedCompany.name,
        },
        requester: {
          id: user?.id,
          name: user?.name,
          email: user?.email,
        },
        id: payload.id,
        initial_conclusion_date: payload.initial_conclusion_date,
        final_conclusion_date: payload.final_conclusion_date,
        ordered_by: payload.ordered_by,
        weed_type_by_culture: payload.weed_type_by_culture,
      }),
    {
      onError() {
        toast.error(
          'Ocorreu um erro ao solicitar o relatório. Tente novamente.',
        )
      },
      onSuccess() {
        toast.info('Relatório solicitado com sucesso.')
        queryClient.invalidateQueries([GET_INFESTATION_REPORTS_QUERY])
      },
    },
  )

  return mutation
}
